/**
 * CoureHub.Addressbook.Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddressBookMappingResponseDto } from '../model/addressBookMappingResponseDto';
import { AddressbookMappingRequestDto } from '../model/addressbookMappingRequestDto';
import { AllAddressBookMappingResponseDto } from '../model/allAddressBookMappingResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AddressBookMappingService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAddressBookMappingDeletAddressBookIdDelete(id: string, observe?: 'body', reportProgress?: boolean): Observable<AddressBookMappingResponseDto>;
    public apiAddressBookMappingDeletAddressBookIdDelete(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddressBookMappingResponseDto>>;
    public apiAddressBookMappingDeletAddressBookIdDelete(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddressBookMappingResponseDto>>;
    public apiAddressBookMappingDeletAddressBookIdDelete(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiAddressBookMappingDeletAddressBookIdDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AddressBookMappingResponseDto>('delete',`${this.basePath}/api/AddressBookMapping/DeletAddressBook/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param addressbookID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAddressBookMappingGetAddressBookByAddressbookIdAddressbookIDGet(addressbookID: string, observe?: 'body', reportProgress?: boolean): Observable<AddressBookMappingResponseDto>;
    public apiAddressBookMappingGetAddressBookByAddressbookIdAddressbookIDGet(addressbookID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddressBookMappingResponseDto>>;
    public apiAddressBookMappingGetAddressBookByAddressbookIdAddressbookIDGet(addressbookID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddressBookMappingResponseDto>>;
    public apiAddressBookMappingGetAddressBookByAddressbookIdAddressbookIDGet(addressbookID: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (addressbookID === null || addressbookID === undefined) {
            throw new Error('Required parameter addressbookID was null or undefined when calling apiAddressBookMappingGetAddressBookByAddressbookIdAddressbookIDGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AddressBookMappingResponseDto>('get',`${this.basePath}/api/AddressBookMapping/GetAddressBookByAddressbookId/${encodeURIComponent(String(addressbookID))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAddressBookMappingGetAddressBookByServiceIdServiceIDGet(serviceID: string, observe?: 'body', reportProgress?: boolean): Observable<AddressBookMappingResponseDto>;
    public apiAddressBookMappingGetAddressBookByServiceIdServiceIDGet(serviceID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddressBookMappingResponseDto>>;
    public apiAddressBookMappingGetAddressBookByServiceIdServiceIDGet(serviceID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddressBookMappingResponseDto>>;
    public apiAddressBookMappingGetAddressBookByServiceIdServiceIDGet(serviceID: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceID === null || serviceID === undefined) {
            throw new Error('Required parameter serviceID was null or undefined when calling apiAddressBookMappingGetAddressBookByServiceIdServiceIDGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AddressBookMappingResponseDto>('get',`${this.basePath}/api/AddressBookMapping/GetAddressBookByServiceId/${encodeURIComponent(String(serviceID))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param ID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAddressBookMappingGetAddressBookMappingByIdIDGet(ID: string, observe?: 'body', reportProgress?: boolean): Observable<AddressBookMappingResponseDto>;
    public apiAddressBookMappingGetAddressBookMappingByIdIDGet(ID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddressBookMappingResponseDto>>;
    public apiAddressBookMappingGetAddressBookMappingByIdIDGet(ID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddressBookMappingResponseDto>>;
    public apiAddressBookMappingGetAddressBookMappingByIdIDGet(ID: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (ID === null || ID === undefined) {
            throw new Error('Required parameter ID was null or undefined when calling apiAddressBookMappingGetAddressBookMappingByIdIDGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AddressBookMappingResponseDto>('get',`${this.basePath}/api/AddressBookMapping/GetAddressBookMappingById/${encodeURIComponent(String(ID))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAddressBookMappingGetAllAddressBookMappingGet(observe?: 'body', reportProgress?: boolean): Observable<AllAddressBookMappingResponseDto>;
    public apiAddressBookMappingGetAllAddressBookMappingGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllAddressBookMappingResponseDto>>;
    public apiAddressBookMappingGetAllAddressBookMappingGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllAddressBookMappingResponseDto>>;
    public apiAddressBookMappingGetAllAddressBookMappingGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AllAddressBookMappingResponseDto>('get',`${this.basePath}/api/AddressBookMapping/GetAllAddressBookMapping`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAddressBookMappingMapAddressBooktoServicePost(body?: AddressbookMappingRequestDto, observe?: 'body', reportProgress?: boolean): Observable<AddressBookMappingResponseDto>;
    public apiAddressBookMappingMapAddressBooktoServicePost(body?: AddressbookMappingRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddressBookMappingResponseDto>>;
    public apiAddressBookMappingMapAddressBooktoServicePost(body?: AddressbookMappingRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddressBookMappingResponseDto>>;
    public apiAddressBookMappingMapAddressBooktoServicePost(body?: AddressbookMappingRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AddressBookMappingResponseDto>('post',`${this.basePath}/api/AddressBookMapping/MapAddressBooktoService`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
